export default __webpack_public_path__ + "60c144f7f5cdc7db5a69a7ef9bb68dc0.png";